export default __webpack_public_path__ + "static/ireland-a2bb16e1548b05eb8396b6cbaebdad24.png";